const SimpleModal = ({ children, show, setShow, additionalClasses, theRef }) => {
  const content = show && (
    <div ref={theRef} className={"lexcms-modal" + ` ${additionalClasses}` }>
      <div className="lexcms-modal-header">
        <div
          className="lexcms-modal-close"
          type="button"
          onClick={() => setShow(false)}
        >
          Close
        </div>
      </div>
      <div className="lexcms-modal-content">{children}</div>
    </div>
  );

  return content;
};

export default SimpleModal;
